export default "__VITE_ASSET__CXeTpjyW__"